import { getBranchAvailability } from './fulfillmentMarket'

const sameProduct = (candidate, requestedProduct) => {
  if (!candidate || !requestedProduct) return false

  if (candidate._id && requestedProduct._id) {
    return String(candidate._id) === String(requestedProduct._id)
  }

  return candidate.name === requestedProduct.name
}

export const resolveOrderProduct = ({ requestedProduct, loadedProducts, cachedProducts }) => {
  const loaded = Array.isArray(loadedProducts) ? loadedProducts : []
  const cached = Array.isArray(cachedProducts) ? cachedProducts : []

  return loaded.find(candidate => sameProduct(candidate, requestedProduct))
    || cached.find(candidate => sameProduct(candidate, requestedProduct))
}

export const productCanBePickedUp = (product, orlando = false) => {
  const orlandoAvailability = getBranchAvailability(product, 'Orlando')
  return Boolean(
    product?.allow_pickup
    && !product?.requires_tech
    && (!orlando || (orlandoAvailability === null ? product?.orlando : orlandoAvailability > 0))
  )
}
